import { createFileRoute, redirect } from '@tanstack/react-router';

/**
 * Bare /dashboard/settings/billing redirects to the first tab. Tab routes
 * live as siblings of this index file under `billing/`.
 */
export const Route = createFileRoute('/_dashboard/dashboard/settings/billing/')({
  beforeLoad: () => {
    throw redirect({ to: '/dashboard/settings/billing/invoices' });
  },
  component: () => null,
});
